export function ContextMenuSeparator() {
    return (
        <div
            role="separator"
            style={{
                height: 1,
                margin: "6px 4px",
                background: "rgba(var(--fx-surface-textrgb, 15, 23, 42), 0.08)",
            }}
        />
    );
}